<template>
    <div v-bind:class="divClasses">
        <slot />
        <div
            v-bind:class="divClasses"
            class="ms-auto">
            <slot name="right" />
        </div>
    </div>
</template>

<script setup>
    import { computed } from "vue";

    const divClasses = computed(() => {
        return ["d-flex", "gap-2", "flex-wrap", "align-items-center"];
    });
</script>
